import React from 'react';
import { Helmet } from 'react-helmet-async';

import { useTranslate } from 'src/shared/hooks';
import { TranslationNamespace } from 'src/shared/hooks/useTranslate';

const Meta = ({ thumbnail }: { thumbnail: string }) => {
  const t = useTranslate(TranslationNamespace.SHARED);

  return (
    <Helmet>
      <meta content={t('renderings.title')} property="og:title" />
      <meta content={t('renderings.description')} name="description" />
      <meta content={t('renderings.description')} property="og:description" />
      <meta content={thumbnail} property="og:image" />
    </Helmet>
  );
};

export { Meta };
